/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetAddressSuggest200Response
 */
export interface GetAddressSuggest200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetAddressSuggest200Response
   */
  status: boolean
  /**
   *
   * @type {Array<string>}
   * @memberof GetAddressSuggest200Response
   */
  data: Array<string>
}

/**
 * Check if a given object implements the GetAddressSuggest200Response interface.
 */
export function instanceOfGetAddressSuggest200Response(
  value: object
): value is GetAddressSuggest200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetAddressSuggest200ResponseFromJSON(
  json: any
): GetAddressSuggest200Response {
  return GetAddressSuggest200ResponseFromJSONTyped(json, false)
}

export function GetAddressSuggest200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetAddressSuggest200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: json['data'],
  }
}

export function GetAddressSuggest200ResponseToJSON(
  value?: GetAddressSuggest200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: value['data'],
  }
}
